var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomeLayout',[_c('canvas',{ref:"bjsCanvas",staticClass:"w-100 h-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }